import React, { useEffect } from 'react';
import { ChemistryParticleField } from './components/ChemistryParticleField';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { ProblemSolution } from './components/ProblemSolution';
import { SystemIntro } from './components/SystemIntro';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferStack } from './components/OfferStack';
import { MaterialPreview } from './components/MaterialPreview';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Wizualna Chemia™ | Edycja 2026 — materiały dla nauczycieli chemii';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', '7 kompletnych tomów i 3 bonusy dla nauczycieli chemii: 568 stron gotowych do wydruku dla klas 7–8, liceum i technikum. Dostęp cyfrowy od razu.');
  }, []);
  return <div className="relative w-full bg-paper text-ink" data-id="element-0" data-mp="3dl4k1ljnffut">
      <ChemistryParticleField data-id="element-1" data-mp="3dii694660445" />

      <div className="relative z-10" data-id="element-2" data-mp="nwc23tmizxws">
        <TopBar data-id="element-3" data-mp="nvaq9mxor7e0" />
        <main data-id="element-4" data-mp="nxwxflgnzkvp">
          <span id="hero-sentinel" aria-hidden="true" data-id="element-5" data-mp="sunb624zy4dy" />
          <Hero data-id="element-6" data-mp="st2iyj65mxj9" />
          <TrustBar data-id="element-7" data-mp="swqcvjfihlyi" />
          <ProblemSolution data-id="element-8" data-mp="36hw15qrsq0p" />
          <SystemIntro data-id="element-9" data-mp="35oxut5vn8u6" />
          <VolumesSection data-id="element-10" data-mp="34x13f0jn52b" />
          <BonusesSection data-id="element-11" data-mp="38b5stwojqcx" />
          <OfferStack data-id="element-12" data-mp="3udawg7dqol46" />
          <MaterialPreview data-id="element-13" data-mp="3ubrhck3tkg3z" />
          <AudienceSection data-id="element-14" data-mp="3ucjdbw1bwfus" />
          <Testimonials data-id="element-15" data-mp="d4nvlgp3tk2e" />
          <HowItWorks data-id="element-16" data-mp="d4xobc1ja5bs" />
          <Guarantee data-id="element-17" data-mp="d3cwvvain2i5" />
          <ClosingBlock data-id="element-18" data-mp="d2l9h7r2ob2y" />
          <FAQ data-id="element-19" data-mp="85l0anyxes7m" />
        </main>
        <Footer data-id="element-20" data-mp="86mf93j2byum" />
        <div className="h-[58px] md:hidden" aria-hidden="true" data-id="element-21" data-mp="86w3alkjrvxo" />
        <FloatingCTA data-id="element-22" data-mp="3gkv2dw2tfxfe" />
      </div>
    </div>;
}